module.exports = __webpack_public_path__ + "img/chervon-left.c7485dec.svg";